
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_site_njord-blueparrott/[[...path]]",
      function () {
        return require("private-next-pages/_site_njord-blueparrott/[[...path]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_site_njord-blueparrott/[[...path]]"])
      });
    }
  